module.exports = __webpack_public_path__ + "img/材料力学8_3_4.b0ea891b.jpg";